import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
	label?: React.ReactNode
	hint?: React.ReactNode
	error?: React.ReactNode
	block?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
	{ label, hint, error, block = true, className, id, children, required, ...rest },
	ref,
) {
	const generatedId = useId()
	const selectId = id ?? generatedId
	return (
		<div className={cn('form-control', block && 'w-full')}>
			{label && (
				<label htmlFor={selectId} className="label pb-1.5">
					<span className="label-text font-medium text-sm">
						{label}
						{required && (
							<span className="text-error ml-0.5" aria-hidden="true">
								*
							</span>
						)}
					</span>
				</label>
			)}
			<select
				ref={ref}
				id={selectId}
				required={required}
				className={cn(
					'select-refined w-full',
					error && 'border-error focus:border-error',
					className,
				)}
				aria-invalid={error ? true : undefined}
				aria-describedby={error || hint ? `${selectId}-help` : undefined}
				{...rest}
			>
				{children}
			</select>
			{(error || hint) && (
				<p
					id={`${selectId}-help`}
					role={error ? 'alert' : undefined}
					className={cn('text-xs mt-1.5', error ? 'text-error' : 'text-base-content/60')}
				>
					{error ?? hint}
				</p>
			)}
		</div>
	)
})
